import { render, staticRenderFns } from "./TopupDialog.vue?vue&type=template&id=18706235"
import script from "./TopupDialog.vue?vue&type=script&lang=js"
export * from "./TopupDialog.vue?vue&type=script&lang=js"
import style0 from "./TopupDialog.vue?vue&type=style&index=0&id=18706235&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports